import { BrowserRouter, Route, Routes } from 'react-router'

import { getClient as getHttpClient } from '@molecule/app-http'
import { MoleculeProvider } from '@molecule/app-react'
import { RootErrorBoundary } from '@molecule/app-root-error-boundary-react'
import { getProvider as getStorageProvider } from '@molecule/app-storage'

import { authClient, i18nProvider, themeProvider } from './bonds/index.js'
import { Footer } from './components/Footer.js'
import { NotFound } from './pages/NotFound.js'
import { Status } from './pages/Status.js'

/**
 * The public Molecule.dev status page. A single unauthenticated route renders
 * the live status page (`Status`) at `/` and `/status`; everything else is a
 * 404. This app watches `api.molecule.dev` from the outside — it has no
 * operator UI of its own.
 */
export function App() {
  return (
    <BrowserRouter>
      <MoleculeProvider
        auth={authClient}
        http={getHttpClient()}
        theme={themeProvider}
        storage={getStorageProvider()}
        i18n={i18nProvider}
      >
        <RootErrorBoundary>
          <Routes>
            <Route path="/" element={<Status />} />
            <Route path="/status" element={<Status />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
        </RootErrorBoundary>
      </MoleculeProvider>
    </BrowserRouter>
  )
}
